import { render, staticRenderFns } from "./nursingTasksInfo.vue?vue&type=template&id=98b00c12&scoped=true&"
import script from "./nursingTasksInfo.vue?vue&type=script&lang=js&"
export * from "./nursingTasksInfo.vue?vue&type=script&lang=js&"
import style0 from "./nursingTasksInfo.vue?vue&type=style&index=0&id=98b00c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b00c12",
  null
  
)

export default component.exports